const initialState = {
  data: null,
  loading: false,
  error: null,
  sortBy: null,
  sortOrder: 'asc',
  page: 0,
  rowsPerPage: 10,
  lastPageType: null,
  lastApiEndpoint: null
};

const DetailPageReducer = (state = initialState, action) => {
  let columnId, newSortOrder, sortedItems;
  switch (action.type) {
    case 'DETAILS_PAGE_LOADER':
      return {
        ...state,
        loading: action.payload,
      };
    case 'FETCH_DETAIL_PAGE_DATA_REQUEST':
      return {
        ...state,
        lastPageType: action.payload.pageType,
        lastApiEndpoint: action.payload.apiEndpoint
      };
    case 'FETCH_DETAIL_PAGE_DATA_START':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'FETCH_DETAIL_PAGE_DATA_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    case 'FETCH_DETAIL_PAGE_DATA_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case 'SORT_DETAIL_PAGE_DATA':
      columnId = action.payload.columnId;
      newSortOrder = state.sortBy === columnId && state.sortOrder === 'asc' ? 'desc' : 'asc';
      sortedItems = state.data?.items ? [...state.data.items].sort((a, b) => {
        const aVal = a[columnId];
        const bVal = b[columnId];
        if (typeof aVal === 'string') {
          return newSortOrder === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        return newSortOrder === 'asc' 
          ? (aVal > bVal ? 1 : -1)
          : (bVal > aVal ? 1 : -1);
      }) : [];
      return {
        ...state,
        sortBy: columnId,
        sortOrder: newSortOrder,
        data: {
          ...state.data,
          items: sortedItems
        }
      };
    case 'CHANGE_DETAIL_PAGE_PAGE':
      return {
        ...state,
        page: action.payload.page
      };
    case 'CHANGE_DETAIL_PAGE_ROWS_PER_PAGE':
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage,
        page: 0
      };
    default:
      return state;
  }
};

export default DetailPageReducer;